import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: 'transparent',
    padding: theme.spacing(3),
  },
  divider: {
    marginBottom: '1rem'
  },
}));

const ActionsCard = ({partner}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  // eslint-disable-next-line react/no-multi-comp
  const SimpleDialog = () => {
    return (
      <Dialog
        aria-labelledby="simple-dialog-title"
        onClose={handleClose}
        open={open}
      >
        <Grid
          alignItems="center"
          container
        >
          <Grid
            item
            sm={6}
            xs={12}
          >
            <Paper elevation={0}>
              <CardMedia
                alt={partner.alt}
                component="img"
                image={partner.img}
                object-fit
                title={partner.name}
              />
            </Paper>
          </Grid>
   
          <Grid
            item
            sm={6}
            xs={12}
          >
            <Paper
              className={classes.paper}
              elevation={0}
            >
              <Typography
                component="h3"
                style={{fontWeight: 'bold'}}
              >
                {partner.title}
              </Typography>
              <Divider
                className={classes.divider}
              />
              <Typography>
                {partner.desc}
              </Typography>
              <Button
                component="a"
                href={partner.link}
                style={{background: '#0164E5', marginTop: '2rem', color: 'white'}}
                target="blank"
              >
                Visiter la page Facebook
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Dialog>
    );
  }
  return (
    <>
      <SimpleDialog
        onClose={handleClose}
        open={open}
      />
      <Card
        elevation={0}
        square
      >
        <Grid container>
          <Grid
            xs={12}
          >
            <CardMedia
              alt={partner.alt}
              component="img"
              image={partner.img}
              object-fit
              title={partner.name}
            />
          </Grid>
          <Grid
            xs={12}
          >
            <Paper
              className={classes.paper}
              elevation={0}
            >
              <Typography
                component="h2"
                style={{fontWeight: 'bold', marginBottom: '1rem'}}
              >
                {partner.title}
              </Typography>
              <Typography>
                {partner.desc.slice(0, 150) + '[...]'}
              </Typography>
              <Button
                color="secondary"
                onClick={handleClickOpen}
                style={{alignSelf: 'center', marginTop: '2rem'}}
                variant="contained"
              >
                En Savoir Plus
              </Button>
            </Paper>
          </Grid>

        </Grid>
      </Card>
    </>
  );
}

ActionsCard.propTypes = {
  partner: PropTypes.object,
};

export default ActionsCard;
